export const RESERVATION_STATUS_MAP: { [key: number]: { label: string; color: string } } = {
  1: { label: 'Referral', color: '#92C7C7' },
  2: { label: 'Intake by EP', color: '#f7c663' },
  3: { label: 'Assessment by EP', color: '#d79206' },
  4: { label: 'Admission', color: '#00cc33' },
  5: { label: 'Tour Scheduled', color: '#4ed1f7' },
  6: { label: 'Assessment by B&C/AL', color: '#7266ba' },
  7: { label: 'Discharge from the Facility', color: '#0e7cb1' },
  8: { label: 'Declined', color: '#e95b73' },
  9: { label: 'Waiting for 602a Form', color: '#570d72' },
  10: { label: '602a Form Uploaded', color: '#686808' },
  11: { label: 'Tour Re-scheduled', color: '#b9973f' },
  12: { label: 'Waiting for Rates Approval', color: '#00bcd4' },
  13: { label: 'Rates Approved', color: '#c9b92d' },
  14: { label: 'Rates Declined', color: '#db5b5b' },
  15: { label: 'Cancelled', color: '#e95b73' }
};

export function getReservationStatus(statusId: number, statusName?: string): { label: string; color: string } {
  if (statusId && RESERVATION_STATUS_MAP[statusId]) {
    return RESERVATION_STATUS_MAP[statusId];
  }
  return {
    label: statusName || (statusId ? `Status ${statusId}` : '—'),
    color: statusId ? '#0e7cb1' : '#6b7280'
  };
}
